import { Button } from '@massilia/ui'
import { FileText } from 'lucide-react'

interface BookingBottomActionsProps {
  onCancel: () => void
  onModify: () => void
}

export function BookingBottomActions({ onCancel, onModify }: BookingBottomActionsProps) {
  return (
    <div className="flex flex-wrap gap-3">
      <Button className="text-xs sm:text-sm" onClick={onModify} type="button">
        Modifier ma réservation
      </Button>
      <Button
        onClick={() => window.open('https://www.traveldoc.aero/fr/')}
        className="text-xs sm:text-sm"
        type="button"
        variant="outline"
      >
        <FileText className="size-4" />
        Condition d&apos;entrées dans le pays
      </Button>
      <Button
        className="border-red-300 text-xs text-red-600 hover:bg-red-50 sm:text-sm"
        onClick={onCancel}
        type="button"
        variant="outline"
      >
        Annuler mon voyage
      </Button>
    </div>
  )
}
